const useNativeStatusBar = () => ({
  nativeStatusBarExist: false,
});

export default useNativeStatusBar;
